export function checkErrorMsg(msg, arr) {
  for (const item of arr) {
    const testMsg = new RegExp(`\\b${item}\\b`, "i");
    if (testMsg.test(msg)) {
      return item;
    }
  }
  return null;
}

export default function handleErrorAPI(error, setState, allState) {

  const key = checkErrorMsg(error?.message, allState);

  setState({
    [key]: error?.message,
  });
}
